/**
 * @generated SignedSource<<23cb4cd2a025fd76414eacb405eafd8d>>
 * @lightSyntaxTransform
 * @nogrep
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

import { Fragment, ReaderFragment } from 'relay-runtime';
import { FragmentRefs } from "relay-runtime";
export type CheckoutLayout_buyer$data = {
  readonly " $fragmentSpreads": FragmentRefs<"BuyerIncentives_buyer" | "CheckoutFooter_buyer" | "CheckoutHelp_buyer" | "CheckoutMobileSummaryPane_buyer" | "CheckoutSidebar_buyer" | "CheckoutSteps_buyer">;
  readonly " $fragmentType": "CheckoutLayout_buyer";
};
export type CheckoutLayout_buyer$key = {
  readonly " $data"?: CheckoutLayout_buyer$data;
  readonly " $fragmentSpreads": FragmentRefs<"CheckoutLayout_buyer">;
};

const node: ReaderFragment = {
  "argumentDefinitions": [],
  "kind": "Fragment",
  "metadata": null,
  "name": "CheckoutLayout_buyer",
  "selections": [
    {
      "args": null,
      "kind": "FragmentSpread",
      "name": "CheckoutSidebar_buyer"
    },
    {
      "args": null,
      "kind": "FragmentSpread",
      "name": "CheckoutSteps_buyer"
    },
    {
      "args": null,
      "kind": "FragmentSpread",
      "name": "CheckoutHelp_buyer"
    },
    {
      "args": null,
      "kind": "FragmentSpread",
      "name": "CheckoutMobileSummaryPane_buyer"
    },
    {
      "args": null,
      "kind": "FragmentSpread",
      "name": "CheckoutFooter_buyer"
    },
    {
      "args": null,
      "kind": "FragmentSpread",
      "name": "BuyerIncentives_buyer"
    }
  ],
  "type": "User",
  "abstractKey": null
};

(node as any).hash = "3475f21895bb3d39ba50e8f9eaaa0c80";

export default node;
